import React from 'react';
import { Link } from 'react-router-dom';

const certifications = [
    {
        label: 'Quality Management System',
        number: '9001',
        color: '#f97316',
    },
    {
        label: 'Environment Management System',
        number: '14001',
        color: '#a3e635',
    },
    {
        label: 'Occupational Health & Safety Management System',
        number: '45001',
        color: '#a78bfa',
    },
];

const IsoCertificationBadge = ({ label, arcLabel = label, number, color }) => {
    const arcId = `certification-arc-${number}`;
    const badgeLabel = arcLabel.toUpperCase();
    const isExtraLongLabel = badgeLabel.length > 40;
    const isLongLabel = badgeLabel.length > 30;

    return (
        <figure className="flex flex-col items-center gap-2 text-center">
            <svg
                className="h-36 w-36 sm:h-40 sm:w-40"
                viewBox="0 0 180 170"
                role="img"
                aria-labelledby={`${arcId}-title`}
            >
                <title id={`${arcId}-title`}>Certificazione ISO {number}: {label}</title>
                <defs>
                    <path id={arcId} d="M 29 108 A 66 66 0 1 1 151 108" />
                </defs>
                <circle cx="90" cy="86" r="48" fill="#171717" stroke="rgba(255,255,255,0.08)" strokeWidth="1" />
                <path
                    d="M 29 108 A 66 66 0 1 1 151 108"
                    fill="none"
                    stroke={color}
                    strokeLinecap="butt"
                    strokeWidth="23"
                />
                <text
                    fill="#fff"
                    fontSize={isExtraLongLabel ? 10.4 : isLongLabel ? 12.4 : 13.8}
                    fontWeight="800"
                    textAnchor="middle"
                    dy="4"
                    textLength={isExtraLongLabel ? 158 : isLongLabel ? 150 : 142}
                    lengthAdjust="spacingAndGlyphs"
                >
                    <textPath href={`#${arcId}`} startOffset="50%">
                        {badgeLabel}
                    </textPath>
                </text>
                <text x="90" y="78" fill="#fff" textAnchor="middle" fontSize="25" fontWeight="800">
                    ISO
                </text>
                <text x="90" y="110" fill="#fff" textAnchor="middle" fontSize="32" fontWeight="900">
                    {number}
                </text>
                <path
                    d="M 58 142 C 70 133, 77 153, 83 162 C 96 146, 118 132, 139 124"
                    fill="none"
                    stroke="#ef4444"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="10"
                />
            </svg>
            <figcaption className="sr-only">ISO {number}</figcaption>
        </figure>
    );
};

const Footer = () => {
    return (
        <footer id="contacts" className="bg-neutral-900 text-white pt-0 pb-8 border-t border-neutral-800">
            <div className="container mx-auto px-6">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
                    <div className="md:col-span-2">
                        <img src="/assets/video/hero/logo_ADER.png" alt="ADER SRL" className="h-48 -mb-10 -ml-6 object-contain object-left-bottom" />
                        <p className="text-gray-400 max-w-md">
                            Con un approccio specializzato in Soluzioni di Copertura e Energia Sostenibile, siamo il partner di fiducia nella gestione dell'involucro edilizio.
                        </p>
                    </div>

                    <div className="mt-12">
                        <h4 className="text-sm uppercase tracking-widest text-gray-500 mb-6">Contatti</h4>
                        <ul className="space-y-4 text-gray-300">
                            <li><a href="mailto:adersrl0030@gmail.com" className="hover:text-white transition-colors">adersrl0030@gmail.com</a></li>
                            <li><a href="tel:+393335375783" className="hover:text-white transition-colors">+39 333 537 5783</a> (Ado)</li>
                            <li><a href="tel:+393497333282" className="hover:text-white transition-colors">+39 349 733 3282</a> (Erald)</li>
                            <li>Via Don Danesin 6/A, Susegana (TV)</li>
                        </ul>
                    </div>

                    <div className="mt-12">
                        <h4 className="text-sm uppercase tracking-widest text-gray-500 mb-6">Dati Fiscali</h4>
                        <ul className="space-y-4 text-gray-300 text-sm">
                            <li>P.IVA: 05404250267</li>
                            <li>Codice Univoco: BA6ET11</li>
                        </ul>
                    </div>
                </div>

                <div className="border-t border-neutral-800 pt-8 pb-10">
                    <h4 className="text-sm uppercase tracking-widest text-gray-500 text-center mb-6">Certificazioni</h4>
                    <div className="flex flex-wrap items-center justify-center gap-5 sm:gap-8">
                        {certifications.map((certification) => (
                            <IsoCertificationBadge key={certification.number} {...certification} />
                        ))}
                    </div>
                </div>

                <div className="border-t border-neutral-800 flex flex-col md:flex-row justify-between items-center text-sm text-gray-500 py-6">
                    <p>&copy; {new Date().getFullYear()} ADER SRL. Tutti i diritti riservati.</p>

                    <a href="https://www.miptechnologies.tech" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 mt-4 md:mt-0 opacity-60 hover:opacity-100 transition-opacity duration-300">
                        <span className="text-xs">Powered by</span>
                        <img src="/assets/video/hero/MIP.png" alt="MIP Technologies" className="h-5 object-contain" />
                        <span className="text-xs font-bold tracking-wider">Technologies</span>
                    </a>

                    <div className="flex space-x-6 mt-4 md:mt-0">
                        <Link to="/privacy-policy" className="hover:text-white">Privacy Policy</Link>
                        <Link to="/cookie-policy" className="hover:text-white">Cookie Policy</Link>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
